import {Component,EventEmitter,Input,OnInit,Output} from '@angular/core';

import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

import { ButtonLoading } from 'src/app/models/button-loading.model';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { CompanyResponse } from 'src/app/models/company.model';

import {
    PassBusinessRequest,
    PassBusinessResponse,
    PassBusinessTypeResponse,
    PASS_BUSINESS_TYPES
} from 'src/app/models/pass-business.model';

import { PassBusinessService } from 'src/app/services/pass-business.service';
import { CompanyService } from 'src/app/services/company.service';
import { ResponseObject } from 'src/app/models/response-object.model';

@Component({
    selector: 'app-modal-pass-business',
    templateUrl: './modal-pass-business.component.html',
    styleUrls: ['./modal-pass-business.component.scss']
})
export class ModalPassBusinessComponent implements OnInit {

    @Input() edit: PassBusinessResponse = null;
    @Input() editCompanyName: string = '';

    @Output() close = new EventEmitter<boolean>();

    buttonSave: ButtonLoading =
        new ButtonLoading('btn-success', false, 'GUARDAR', 'fa-save');

    // Compañías
    companies: CompanyResponse[] = [];
    allCompanies: CompanyResponse[] = [];

    selected: CompanyResponse = null;

    inputs = new InputAutocompleteModel(
        '',
        false,
        true,
        '',
        'fa-asterisk',
        '',
        '',
        null,
        []
    );

    timeout: any = null;
    gettingCompanies: boolean = false;

    // Formulario
    request: PassBusinessRequest = new PassBusinessRequest();

    confirmPass: string = '';

    // Tipos
    types: PassBusinessTypeResponse[] = PASS_BUSINESS_TYPES;

    constructor(
        private toastService: ToastrService,
        private companyService: CompanyService,
        private passBusinessService: PassBusinessService
    ) { }

    ngOnInit(): void {

        if (this.edit) {

            this.request.id = this.edit.id;
            this.request.company = this.edit.company;
            this.request.type = this.edit.type;

            // El valor existente no se muestra automáticamente.
            this.request.pass = '';
            this.confirmPass = '';

            this.buttonSave.message = 'ACTUALIZAR';

        } else {

            this.getAllCompanies();
        }
    }

    /**
     * Obtener todas las compañías activas.
     *
     * Para agregar un pass no se necesitan permisos
     * de lectura sobre los secretos de la compañía.
     */
    getAllCompanies() {

        this.gettingCompanies = true;

        this.companyService.getAllCompanies().subscribe({
            next: (response: ResponseObject) => {

                const companies = (response.data || []) as CompanyResponse[];

                this.allCompanies = companies.filter(company =>
                    company.active === true
                );

                this.companies = [...this.allCompanies];

                this.gettingCompanies = false;
            },
            error: (error: HttpErrorResponse) => {

                this.gettingCompanies = false;

                this.toastService.error(
                    error.error?.message ||
                    'Error al obtener las compañías activas'
                );
            }
        });
    }

    /**
     * Buscar compañía.
     */
    searchCompany() {

        clearTimeout(this.timeout);

        this.inputs.verified = false;
        this.selected = null;
        this.inputs.class = 'typing';

        this.timeout = setTimeout(() => {

            const value = (this.inputs.value || '')
                .toString()
                .toLowerCase()
                .trim();

            this.companies = this.allCompanies.filter(company => {

                const name = (company.name || '').toLowerCase();
                const nit = (company.nit || '').toLowerCase();

                const code = (company.alphanumericId || '')
                    .toLowerCase();

                const id = String(company.id || '');

                return name.includes(value)
                    || nit.includes(value)
                    || code.includes(value)
                    || id.includes(value);
            });

            this.inputs.class = this.companies.length > 0
                ? 'fa-list'
                : 'fa-xmark';

        }, 300);
    }

    /**
     * Seleccionar compañía.
     */
    selectCompany(company: CompanyResponse) {

        if (!company) {
            return;
        }

        this.selected = company;
        this.request.company = company.id;

        this.inputs.value =
            company.alphanumericId +
            ' - ' +
            company.nit +
            ' - ' +
            company.name;

        this.inputs.verified = true;
        this.inputs.class = 'fa-circle-check';
    }

    /**
     * Validar formulario.
     */
    isValid(): boolean {

        if (!this.request.company) {
            return false;
        }

        if (!this.request.type) {
            return false;
        }

        if (!this.request.pass || !this.request.pass.trim()) {
            return false;
        }

        if (!this.confirmPass) {
            return false;
        }

        if (this.request.pass !== this.confirmPass) {
            return false;
        }

        return true;
    }

    /**
     * Guardar o actualizar.
     */
    savePassBusiness() {

        if (this.buttonSave.loading || !this.isValid()) {
            return;
        }

        this.buttonSave.loading = true;

        const request = new PassBusinessRequest();

        request.id = this.edit ? this.edit.id : null;
        request.company = this.request.company;
        request.type = Number(this.request.type);
        request.pass = this.request.pass;

        const operation = this.edit
            ? this.passBusinessService.updatePassBusiness(request)
            : this.passBusinessService.savePassBusiness(request);

        operation.subscribe({
            next: () => {

                this.buttonSave.loading = false;

                this.toastService.success(
                    this.edit
                        ? 'Contraseña actualizada correctamente'
                        : 'Contraseña guardada correctamente'
                );

                this.close.emit(true);
            },
            error: (error: HttpErrorResponse) => {

                this.buttonSave.loading = false;

                this.toastService.error(
                    error.error?.message ||
                    'Error al guardar la contraseña'
                );
            }
        });
    }

    cancel() {
        this.close.emit(false);
    }
}